import { ca } from '@cian/analytics';
import { EQueryParameters } from '../../repositories/feed-page/v2/mobile-site/get-recommendations';
import { getPageExtra } from '../../utils/tracking';
import { TProduct, TRecommendation } from '../../types/recommendation';
import { mlSearchSession } from '../../utils/mlSearchSession';

export function trackMoreButtonClick(landingType: EQueryParameters, modelVersion: string) {
  // @ts-expect-error Это хак связи микрофронта с мкс. Событие только на фронте.
  const CianAnalytics = window.CianAnalytics;

  if (!CianAnalytics) {
    setTimeout(() => trackMoreButtonClick(landingType, modelVersion), 5);

    return;
  }

  const page = CianAnalytics.service.config.page || {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_similar_offers_click_more',
    label: 'user-based',
    modelVersion,
    page:
      landingType !== EQueryParameters.MainPage
        ? {
            ...page,
            extra: getPageExtra(landingType),
          }
        : undefined,
  });
}

export const trackRecommendationsView = (landingType: EQueryParameters, modelVersion: string, products: TProduct[]) => {
  // @ts-expect-error Это хак связи микрофронта с мкс. Событие только на фронте. Ждем инициализации аналитики у родителя
  const CianAnalytics = window.CianAnalytics;

  if (!CianAnalytics) {
    setTimeout(() => trackRecommendationsView(landingType, modelVersion, products), 5);

    return;
  }

  const page = CianAnalytics.service.config.page || {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_similar_offers',
    label: 'user-based',
    modelVersion,
    page:
      landingType !== EQueryParameters.MainPage
        ? {
            ...page,
            extra: getPageExtra(landingType),
          }
        : undefined,
    products,
  });
};

export const trackRecommendationItemClick = (
  landingType: EQueryParameters,
  modelVersion: string,
  products: [TProduct],
) => {
  // @ts-expect-error Это хак связи микрофронта с мкс. Событие только на фронте.
  const CianAnalytics = window.CianAnalytics;

  if (!CianAnalytics) {
    setTimeout(() => trackRecommendationItemClick(landingType, modelVersion, products), 5);

    return;
  }

  const page = CianAnalytics.service.config.page || {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_offers',
    label: 'user-based',
    modelVersion,
    page:
      landingType !== EQueryParameters.MainPage
        ? {
            ...page,
            extra: getPageExtra(landingType),
          }
        : undefined,
    products,
  });
};

type TTrackTeaserShowOfferData = Pick<TRecommendation, 'offerId' | 'contextToken'> & {
  position: number;
};

type TTrackTeaserShowOptions = {
  isMobile: boolean;
  offersQty: number | null;
};

// Живёт до загрузки новой страницы и сохраняется при перемонтировании микрофронтенда.
const shownTeaserOfferIds = new Set<number>();

export function trackEntityTeaserShow(
  offerData: TTrackTeaserShowOfferData,
  { isMobile, offersQty }: TTrackTeaserShowOptions,
) {
  const { offerId, contextToken, position } = offerData;

  if (!offerId || shownTeaserOfferIds.has(offerId)) {
    return;
  }

  ca('teaser', {
    page: {
      pageType: 'Home',
      siteType: isMobile ? 'mobile' : 'desktop',
      extra: {
        ...(isMobile && { mobileWebsiteType: 'new' }),
        mlSearchSessionGuid: mlSearchSession.getSessionGuid(),
      },
      ...(offersQty !== null && { offersQty }),
    },
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
        ...(contextToken ? { context_token: contextToken } : null),
      },
      position,
      screen: 'Home',
      block: 'Recommendations',
    },
  });

  shownTeaserOfferIds.add(offerId);
}
